import React, { useState } from 'react';
import { useUser } from '../context/UserContext';

const API = process.env.REACT_APP_API_URL || '';

export default function LoginScreen() {
  const { login } = useUser();
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const legacyLogin = process.env.REACT_APP_ALLOW_LEGACY_LOGIN !== 'false';

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!legacyLogin || !username.trim()) return;

    setLoading(true);
    setError('');

    try {
      const res = await fetch(`${API}/api/user/${username.trim()}`);
      if (!res.ok) {
        const data = await res.json();
        setError(data.detail || 'Username not found. Make sure it matches your Sleeper username exactly.');
        setLoading(false);
        return;
      }
      const userData = await res.json();
      login(userData);
    } catch (err) {
      setError('Could not connect to server. Is the backend running?');
    }
    setLoading(false);
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <div style={styles.logo}>⚡</div>
        <h1 style={styles.title}>Dynasty Command Center</h1>
        <p style={styles.subtitle}>Dynasty · PPR · 10 Teams</p>

        <div style={styles.divider} />

        <p style={styles.prompt}>
          {!legacyLogin
            ? 'Use the private sign-in link sent to you by the commissioner.'
            : 'Enter your Sleeper username to get your personalized dashboard'}
        </p>

        {legacyLogin && <form onSubmit={handleLogin} style={styles.form}>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Your Sleeper username"
            style={styles.input}
            autoFocus
            autoComplete="off"
            autoCapitalize="none"
          />
          <button type="submit" style={styles.button} disabled={loading || !username.trim()}>
            {loading ? 'Looking you up…' : 'Enter League →'}
          </button>
        </form>}

        {error && <p style={styles.error}>{error}</p>}

        <p style={styles.hint}>
          Not in this league?{' '}
          <button style={styles.guestBtn} onClick={() => login({ guest: true, display_name: 'Guest', roster_id: null })}>
            Browse as guest
          </button>
        </p>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 50%, #16213e 100%)',
    padding: '20px',
  },
  card: {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '20px',
    padding: '48px 40px',
    maxWidth: '420px',
    width: '100%',
    textAlign: 'center',
    backdropFilter: 'blur(20px)',
    boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
  },
  logo: {
    fontSize: '48px',
    marginBottom: '12px',
  },
  title: {
    color: '#fff',
    fontSize: '24px',
    fontWeight: '700',
    margin: '0 0 6px 0',
    letterSpacing: '-0.5px',
  },
  subtitle: {
    color: 'rgba(255,255,255,0.4)',
    fontSize: '13px',
    margin: '0',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  divider: {
    height: '1px',
    background: 'rgba(255,255,255,0.08)',
    margin: '28px 0',
  },
  prompt: {
    color: 'rgba(255,255,255,0.65)',
    fontSize: '14px',
    marginBottom: '20px',
    lineHeight: '1.5',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  input: {
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: '10px',
    padding: '14px 16px',
    color: '#fff',
    fontSize: '16px',
    outline: 'none',
    transition: 'border-color 0.2s',
  },
  button: {
    background: 'linear-gradient(135deg, #7c3aed, #4f46e5)',
    border: 'none',
    borderRadius: '10px',
    padding: '14px',
    color: '#fff',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'opacity 0.2s',
  },
  error: {
    color: 'var(--red)',
    fontSize: '13px',
    marginTop: '12px',
    padding: '10px 14px',
    background: 'rgba(239,68,68,0.1)',
    borderRadius: '8px',
    border: '1px solid rgba(239,68,68,0.2)',
  },
  hint: {
    color: 'rgba(255,255,255,0.3)',
    fontSize: '13px',
    marginTop: '24px',
  },
  guestBtn: {
    background: 'none',
    border: 'none',
    color: 'rgba(255,255,255,0.5)',
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: '13px',
    padding: 0,
  },
};
